import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Buildings.css';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimpleTable from 'components/shared/table/SimpleTable';
import {
  goToBuilding,
  loadBuildingDetailsRequest,
  loadBuildingsRequest,
  newBuilding,
} from 'actions/admin/buildings/buildings';
import SimpleText from 'components/shared/text/SimpleText';
import {
  getBuildings,
  getBuildingsCurrentPage,
  getBuildingsTotal,
  getBuildingsPageSize,
} from 'selectors/admin/buildings/buildings';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { getCurrentUser } from 'selectors/authentication';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import SimplePagination from 'components/shared/pagination/SimplePagination';

class Buildings extends Component {
  componentDidMount() {
    this.props.dispatch(loadBuildingsRequest(1));
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleAddBuilding = (event) => {
    event.preventDefault();
    this.props.dispatch(newBuilding());
  };

  handleGenerateLink = (index) => {
    const { buildings } = this.props;
    return `buildings/${buildings[index].id}`;
  };

  mapBuildings = (buildings) => {
    return buildings.map((building) => {
      return [
        <SimpleText
          lines={[building.location.street_address_1, building.location.city]}
          style={{ fontWeight: 600 }}
        />,
        building.name !== '' && building.name !== null ? building.name : 'N/A',
        building.property_owner_name || 'N/A',
        Buildings.renderContactName(building.property_manager),
        Buildings.renderContactName(building.engineer),
      ];
    });
  };

  static renderContactName(contact) {
    let result = 'N/A';
    if (
      contact !== null &&
      (contact.first_name !== '' || contact.last_name !== '')
    ) {
      result = contact.first_name + ' ' + contact.last_name;
    }

    return result;
  }

  handleBuildingSelection = (index) => {
    const loadClients =
      usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    this.props
      .dispatch(
        loadBuildingDetailsRequest(this.props.buildings[index].id, loadClients)
      )
      .then((response) => {
        // When building is loaded successfully, go to building page
        if (response.ok) {
          simpleScrollToTop();
          this.props.dispatch(goToBuilding(this.props.buildings[index].id));
        }
      });
  };

  handleBuildingsPageChange = (newPage) => {
    this.props.dispatch(loadBuildingsRequest(newPage));
  };

  render() {
    return (
      <div className="buildings">
        <div className="full-title">Buildings</div>

        <div className="content-container">
          <SearchBar
            addButton={
              usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
              usersUtil.hasType(
                this.props.currentUser,
                TYPES.GENERAL_CONTRACTOR
              ) ||
              usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) ? (
                <input
                  className={'btn button button-orange'}
                  type="button"
                  value="Add Building"
                  onClick={this.handleAddBuilding}
                />
              ) : null
            }
          >
            &nbsp;
          </SearchBar>

          <SimpleTable
            className="buildings-table"
            headers={[
              'ADDRESS',
              'BUILDING NAME',
              'PROPERTY OWNER',
              'PROPERTY MANAGER',
              'BUILDING ENGINEER',
            ]}
            rows={this.mapBuildings(this.props.buildings)}
            emptyMessage="No Buildings"
            onRowSelected={this.handleBuildingSelection}
            onGenerateLink={this.handleGenerateLink}
          />

          <div className="pagination-container">
            <SimplePagination
              currentPage={this.props.buildingsCurrentPage}
              pageSize={this.props.buildingsPageSize}
              total={this.props.buildingsTotal}
              onPageChange={this.handleBuildingsPageChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    buildings: getBuildings(state),
    currentUser: getCurrentUser(state),
    buildingsCurrentPage: getBuildingsCurrentPage(state),
    buildingsTotal: getBuildingsTotal(state),
    buildingsPageSize: getBuildingsPageSize(state),
  };
})(Buildings);



// WEBPACK FOOTER //
// ./src/components/admin/buildings/Buildings.js